import React from "react";
import { Text, useMediaQuery } from "@chakra-ui/react";
import { type Integration, type IntegrationSimple } from "lib/sanity";
import { Section } from "components/section";
import { chunk } from "lodash";
import { integrationsCount, sourcesCount } from "../../../constants/integrations";
import { XtoYLinkSlider } from "../x-y-link-slider";

type PaginatedLinksProps = {
  primaryIntegration: Integration;
  allIntegrations: IntegrationSimple[];
  variant: "allDestinations" | "allSources";
};

function PaginatedLinks({ primaryIntegration, allIntegrations, variant }: PaginatedLinksProps) {
  const [isMobile] = useMediaQuery("(max-width: 800px)");
  const destinationChunks = chunk(allIntegrations, 10);

  return (
    <Section bg="blue.50">
      <Text as="h2" textStyle="h5" mb={8}>
        All {variant === "allDestinations" ? integrationsCount : sourcesCount}+{" "}
        <Text as="span" color="blue.300">
          {primaryIntegration.name}
        </Text>{" "}
        integrations
      </Text>
      <XtoYLinkSlider
        variant={variant}
        primaryIntegration={primaryIntegration}
        integrationChunks={destinationChunks}
        slidesPerView={isMobile ? 1 : 3}
      />
    </Section>
  );
}

export default PaginatedLinks;
